import React from 'react';
import { useLocation } from 'react-router-dom';
import { useSidebarState } from '../../../hooks/useSidebarState';
import { SidebarMenuItem } from './SidebarMenuItem';
import { getMenuItems, menuGroups } from './menuItems';
import { motion } from 'framer-motion';
import { useLanguage } from '../../../contexts/LanguageContext';
import { useTeamStore } from '../../../stores/teamStore';

export const SidebarNav = () => {
  const location = useLocation();
  const { isCollapsed } = useSidebarState();
  const { direction, translations } = useLanguage();
  const userRole = localStorage.getItem('userRole') || 'admin';
  const userId = localStorage.getItem('userId');
  const roleId = localStorage.getItem('roleId');
  const { roles } = useTeamStore();

  // Get user's role and menu item permissions
  const role = roleId ? roles[roleId] : null;
  const menuItemPermissions = role?.menuItems || {};

  const menuItems = getMenuItems(userRole, translations);

  // Filter menu items based on role permissions
  const filteredMenuItems = menuItems.filter(item => {
    // If no specific permissions are set, show the item
    if (!menuItemPermissions[item.path] && menuItemPermissions[item.path] !== false) {
      return true;
    }
    return menuItemPermissions[item.path];
  });

  // Group menu items by category
  const groupedItems = Object.entries(menuGroups(translations))
    .map(([key, label]) => ({
      key,
      label,
      items: filteredMenuItems.filter(item => item.group === key)
    }))
    .filter(group => group.items.length > 0); // Only show groups with items

  const container = {
    hidden: { opacity: 0 },
    show: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const item = {
    hidden: { opacity: 0, x: 20 },
    show: { opacity: 1, x: 0 }
  };

  return (
    <motion.nav 
      variants={container}
      initial="hidden"
      animate="show"
      className="px-3 overflow-y-auto max-h-[calc(100vh-8rem)] scrollbar-thin scrollbar-thumb-gray-200 hover:scrollbar-thumb-gray-300"
    >
      <div className="space-y-6">
        {groupedItems.map(({ key, label, items }) => (
          <div key={key}>
            {!isCollapsed && (
              <motion.div 
                variants={item}
                className="text-xs font-medium text-gray-400 px-4 mb-2"
              >
                {label}
              </motion.div>
            )}
            <motion.div variants={item} className="space-y-1">
              {items.map((item) => (
                <SidebarMenuItem
                  key={item.path}
                  {...item}
                  isActive={location.pathname === item.path}
                  isCollapsed={isCollapsed}
                />
              ))}
            </motion.div>
          </div>
        ))}
      </div>
    </motion.nav>
  );
};